import React from 'react';

export default function StepCard({ number, label, description }) {
  return (
    <div className='flex w-full flex-col rounded-lg bg-surface px-4 py-4'>
      <span className='font-sans text-[26px] font-bold italic text-stepTint leading-none'>
        {number}
      </span>
      <p className='mt-3 font-sans text-sm font-medium text-ink whitespace-pre-line'>{label}</p>
      {description && (
        <p className='mt-1.5 font-sans text-xs text-ink/60 whitespace-pre-line'>{description}</p>
      )}
    </div>
  );
}
